import { SideMenuLeftConfig } from '../../../components/SideMenu/props';

const accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18',
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px',
      },
      iconButton: {
        height: '24px',
        width: '24px',
      },
    },
  },
};

export const sideMenuLeft: SideMenuLeftConfig = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: true,
      amountLeft: 5,
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerAssineAgora',
          href: process.env.NEXT_PUBLIC_URL_LOJA,
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%',
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%',
          },
          iconColor: 'basicBlack',
        },
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerAssineAgora',
          href: process.env.NEXT_PUBLIC_URL_LOJA,
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '149px',
            px: '$2',
            width: '100%',
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%',
          },
          iconColor: 'basicBlack',
        },
      },
      ASSINANTE: {
        logo: {
          name: 'BannerAssineAgora',
          href: process.env.NEXT_PUBLIC_URL_LOJA,
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%',
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%',
          },
          iconColor: 'basicBlack',
        },
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerAnuncie',
          href: '/',
        },
        css: {
          container: {
            align: ["column", "center", "top"],
            backgroundColor: "#081632",
            height: "149px",
            px: "$2",
            width: "100%",
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%',
          },
          iconColor: 'basicBlack',
        },
      },
      club_subscriber: {
        logo: {
          name: 'BannerClube',
          href: '/',
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundImage:
              'url(assets/opopular/banners/BannerClubeBackground.png)',
            height: '149px',
            px: '$2',
            width: '100%',
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%',
          },
          iconColor: 'basicWhite',
        },
      },
    },
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true,
    },
    serviceButtons: {
      enabled: true,
      items: [
        {
          id: 'whatsapp',
          href: 'https://api.whatsapp.com/send?phone=5563999785108',
          variant: 'WhatsApp',
        },
        {
          id: 'jornaldigital',
          href: 'https://www.jornaldotocantins.com.br/digital/',
          variant: 'JornalDigital',
        },
      ],
    },
    navigationAccordions: {
      enabled: true,
      css: accordionStyle,
      items: [
/*         {
          id: 'publicidade',
          title: 'Publicidade',
          items: [
            {
              id: "1",
              title: "Infomercial",
              href: "/infomercial",
            }
          ],
          css: accordionStyle,
        }, */
        {
          id: 'sac',
          title: 'SAC',
          items: [
            {
              id: '1',
              title: 'Fale Conosco',
              href: '/fale-conosco',
            },
            {
              id: "2",
              title: "Expediente",
              href: "/institucional/expediente",
            },
            {
              id: "3",
              title: "Política de privacidade",
              href: "/institucional/politica-de-privacidade",
            },
            {
              id: "4",
              title: "Termos de uso",
              href: "/institucional/termos-de-uso",
            },
          ],
          css: accordionStyle,
        },
        {
          id: 'grupoojc',
          title: 'Grupo Jaime Câmara',
          items: [
            {
              id: '1',
              title: 'Classi',
              href: 'https://www.classi.com.br',
            } /* 
            {
              id: '2',
              title: 'Clube O Popular',
              href: 'https://clube.opopular.com.br'
            }, */,
            {
              id: '2',
              title: 'Jornal Daqui',
              href: 'https://daqui.opopular.com.br',
            },
            {
              id: '3',
              title: 'O Popular',
              href: 'https://opopular.com.br/',
            },
          ],
          css: accordionStyle,
        },
      ],
    },
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: true,
      color: "#081632",
      href: "https://uaiz.opopular.com.br/anuncie-jtoc",
    },
    socialmediasSection: {
      enabled: true,
      color: '#F7F7F7',
      content: [
        {
          id: 'facebook',
          href: 'https://www.facebook.com/JornaldoTocantins',
          icon: 'IcBotaoFacebookCinza',
        },
        {
          id: 'twitter',
          href: 'https://twitter.com/jornaltocantins',
          icon: 'IcBotaoTwitterCinza',
        },
        {
          id: 'instagram',
          href: 'https://www.instagram.com/jornaldotocantins/',
          icon: 'IcBotaoInstagramCinza',
        },
        {
          id: 'whatsapp',
          href: 'https://api.whatsapp.com/send?phone=5563999785108',
          icon: 'IcBotaoWhatsAppCinza',
        },
      ],
    },
  },
};
